import { Outlet } from "react-router-dom";
import TabelaGrupoSede from "./components/tabela";


const Atividade = () => {


  return (
    <>
      <Outlet />
      <TabelaGrupoSede />
    </>
  )
}

export default Atividade;
